module.exports = __webpack_public_path__ + "img/ladderkoord.93121da4.png";